import { AxiosInstance } from 'axios'

import { useQuery } from 'react-query'

import { useSvcLiveblocksContext } from '@dc-shared-web/providers'

export type SvcLiveblocksPostRoomsInfoResponse = {
  id: string
  crunchName: string
  checklistName: string
}[]

const resolveRooms = async (
  apiClient: AxiosInstance,
  roomIds: string[]
): Promise<SvcLiveblocksPostRoomsInfoResponse> => {
  const { data } = await apiClient.post<SvcLiveblocksPostRoomsInfoResponse>(
    '/api/rooms/resolve-info',
    { roomIds }
  )

  return data
}

export const useResolveRooms = (roomIds: string[]) => {
  const apiClient = useSvcLiveblocksContext()

  return useQuery<SvcLiveblocksPostRoomsInfoResponse, Error>({
    queryKey: ['liveblocks-resolve-room', ...roomIds],
    queryFn: () => resolveRooms(apiClient, roomIds),
    enabled: roomIds.length > 0,
  })
}
